import jsonApi from '../json-api-client';
import serialize from 'devour-client/lib/middleware/json-api/_serialize';
import ModalManager from './modalManager';
import PastAppointmentNotificationModal from '../components/Calendar/PastAppointmentNotificationModal.vue';

const isEnabled = () => document.head.querySelector('meta[name="past-appointment-notification-warning-enabled"]')?.content === '1';

/**
 * Asks the backend whether applying the given proposed changes to an existing appointment would
 * cause a patient "appointment modified" notification email to be sent for a start that is (now)
 * in the past. `apiEvent` must contain at least `type` (without the `_resource` suffix), `id`,
 * and the proposed `start`/`end`/`location`.
 */
export const wouldSendPastAppointmentNotification = async(apiEvent) => {
    if (!isEnabled()) {
        return false;
    }

    const response = await jsonApi.axios.post(
        `${jsonApi.apiUrl}/calendar_items/${apiEvent.id}/past_appointment_notification_check`,
        { data: serialize.resource.call(jsonApi, `${apiEvent.type}_resource`, apiEvent) },
        {
            headers: {
                'Content-Type': 'application/vnd.api+json',
                Accept: 'application/json',
            },
        }
    );

    return response.data.WouldSendModificationNotification;
};

/**
 * Shows the opt-out popup. Resolves 'send' or 'suppress' when the user made an explicit choice,
 * or 'cancel' when the modal was dismissed without answering (X, ESC, or the cancel link) —
 * callers must treat 'cancel' as "abort the whole move", not just "keep the notification".
 */
export const confirmPastAppointmentNotification = () => {
    return new Promise(resolve => {
        ModalManager.openModal(PastAppointmentNotificationModal, {}, {
            send: () => resolve('send'),
            suppress: () => resolve('suppress'),
        }, 'medium').then(() => resolve('cancel'));
    });
};
